module.exports = __webpack_public_path__ + "img/send.5bf4fe49.svg";